import Swiper, {EffectFade, Navigation, Thumbs} from 'swiper';

Swiper.use([Navigation, Thumbs, EffectFade]);

export function initSlider() {
  let swiper;
  const breakpoint = window.matchMedia('(min-width:1441px)');

  function breakpointChecker() {
    if (breakpoint.matches) {
      if (swiper !== undefined) {
        swiper.destroy(true, true);
      }
      return;
    } else {
      if (document.querySelectorAll('.js-teaserSlider').length) {
        swiper = new Swiper('.js-teaserSlider', {
          initialSlide: 1,
          centeredSlides: true,
          spaceBetween: 30,
          slidesPerView: 1.4,
          breakpoints: {
            460: {
              slidesPerView: 1.4,
            },
            786: {
              slidesPerView: 2.5,
            },
            1441: {
              slidesPerView: 4,
            },
          },
        });
      }
    }
  }

  breakpointChecker();
  breakpoint.addEventListener('change', breakpointChecker);
}

export function initSwiperGallery() {
  const thumbs = document.querySelectorAll('.js-swiper-gallery-thumbs[data-uid]');
  thumbs.forEach((thumb) => {
    const dataUid = thumb.getAttribute('data-uid');
    const swiperGalleryThumbs = new Swiper(`.js-swiper-gallery-thumbs[data-uid="${dataUid}"]`, {
      spaceBetween: 50,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    const swiperGallery = new Swiper(`.js-swiper-gallery[data-uid="${dataUid}"]`, {
      effect: 'fade',
      thumbs: {
        swiper: swiperGalleryThumbs,
      },
    });

    swiperGalleryThumbs.on('activeIndexChange', function (e) {
      swiperGallery.slideToLoop(e.realIndex);
    });
  });
}

export function initSwiperTimeline() {

  const swiperDetails = new Swiper('.js-swiper-timeline-thumbs', {
    spaceBetween: 20,
    slidesPerView: 1,
    freeMode: true,
    allowTouchMove: false,
    watchSlidesProgress: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        allowTouchMove: true,
      },
      1441: {
        slidesPerView: 5,
        allowTouchMove: true,
      },
    },
  });
  const swiperTimeline = new Swiper('.js-swiper-timeline', {
    spaceBetween: 10,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiperDetails,
    },
    breakpoints: {
      769: {
        autoHeight: false,
      },
      1441: {
        autoHeight: false,
      },
    },
  });
}

export function initPageTeaserSlider() {
  const pageTeaserElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-pageTeaserSlider');
  const pageTeaserSliderElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-pageTeaserSliderThumbs');

  if (pageTeaserElements.length && pageTeaserSliderElements.length) {
    pageTeaserSliderElements.forEach((teaserSliderElement) => {
      const sliderId = teaserSliderElement.dataset.sliderId;

      if (!sliderId) {
        return;
      }

      const projectSliderThumbs = new Swiper(teaserSliderElement, {
        spaceBetween: 0,
        slidesPerView: 1,
        freeMode: true,
        loop: false,
        watchSlidesProgress: true,
        breakpoints: {
          1440: {
            slidesPerView: 5,
            loop: false,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      let sliderElement: HTMLElement | null = null;
      pageTeaserElements.forEach((teaserElement) => {
        if (teaserElement.dataset.sliderId === sliderId) {
          sliderElement = teaserElement;
        }
      });

      if (!sliderElement) {
        return;
      }

      const projectSlider = new Swiper(sliderElement, {
        effect: 'fade',
        thumbs: {
          swiper: projectSliderThumbs,
        },
      });

      teaserSliderElement.querySelectorAll('.js-pageThumb').forEach((projectThumb: HTMLElement) => {
        projectThumb.addEventListener('focus', () => {
          const index = projectThumb.dataset.index;
          if (index) {
            projectSlider?.slideTo(parseInt(index, 10));
          }
        });
      });

      // update projectSlider on change of active statement of thumb slider
      projectSliderThumbs.on('activeIndexChange', function (e) {
        projectSlider.slideToLoop(e.realIndex);
      });
    });
  }


}
